import React from "react";
import EarthHero from "../assets/video/EarthHero.mp4";
import Video from "../assets/video/video.mp4";
import {useTranslation} from "react-i18next";
const Banner = () => {
  const [ t ] = useTranslation(['home']);
  return (
    <div className="hero-section">
      <video
        playsInline
        autoPlay
        loop
        autobuffer
        muted
        src={Video}
        className="big-image__video-background"
      ></video>
      <div className="hero-section__wrapper">
        <div className="row pt-5">
          <div className="col-12 col-lg-6 text-banner">
            <div className="hero-section__text-wrap">
              <label className="section-subtitle">RACKS METAVERSE</label>
              <h1 className="hero-title rleft">
                {t("theFutureOf")}<br></br>ecommerce
              </h1>
              <p>
                {t("BannerHeadDescription")}<br/> WAGMI
              </p>
              <a href="#NFTsSection" className="btn-native-child ">
                {t("Discoverit")}
              </a>
            </div>
          </div>

          <div className="col-6 iframe-wrapper  pt-5">
            <iframe
              className="iframePlanet"
              title="Earthquakes - 2000 to 2019"
              frameBorder="0"
              allowFullScreen=""
              mozallowfullscreen="true"
              webkitallowfullscreen="true"
              allow="autoplay; fullscreen; xr-spatial-tracking"
              xr-spatial-tracking=""
              execution-while-out-of-viewport=""
              execution-while-not-rendered=""
              web-share=""
              src="https://sketchfab.com/models/fb78f4cc938144e6902dd5cff354d525/embed?autospin=1&amp;autostart=1&amp;annotations_visible=0&amp;transparent=1&amp;ui_animations=0&amp;ui_infos=0&amp;ui_stop=0&amp;ui_inspector=0&amp;ui_watermark_link=0&amp;ui_watermark=0&amp;ui_hint=0&amp;ui_ar=0&amp;ui_help=0&amp;ui_settings=0&amp;ui_vr=0&amp;ui_fullscreen=0&amp;ui_annotations=0"
            ></iframe>
            {/*<video playsInline autoPlay loop autobuffer muted className="w-100" src={EarthHero}></video>*/}
          </div>
        </div>
      </div>
    </div>
    // <div className="">
    //     <video playsInline autoPlay loop autobuffer muted
    //            src={Video}
    //            className="big-image__video-background"></video>
    //     <div className="container  pt-10 pb-10">
    //         <div className="row pt-5">
    //             <div className="col-12 col-lg-6 mt-5">
    //                 <label className="colordisabled l-SyncopateBold">RACKS METAVERSE</label>
    //                 <h1 className="rleft">el futuro del ecommerce</h1>
    //                 <p>Contruimos el <span>futuro del ecommerce</span>  a través de las experiencias.  <br/>
    //                     Entra en el <span>metaverso de Racks Mafia</span> y cambia el paradigma de las <br/>
    //                     compras en internet.
    //                 </p>
    //                 <div className="row">
    //                     <div className="col-12 col-lg-4">
    //                         <div className="btn-native" href="#">
    //                             <span className="btn-native-child ">
    //                                 DESCUBRELO
    //                             </span>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //             <div className="col-12 col-lg-6">
    //                 <img className="w-100" src={EarthHero}/>
    //             </div>
    //         </div>
    //     </div>
    // </div>
  );
};

export default Banner;
